import { AccountActivatedModal } from '~/components/modals/AccountActivatedModal';
import { AdminUserAddedModal } from '~/components/modals/AdminUserAddedModal';
import { AdminUserCreateModal } from '~/components/modals/AdminUserCreateModal';
import { AdminUserEditModal } from '~/components/modals/AdminUserEditModal';
import { DepartmentCreateModal } from '~/components/modals/DepartmentCreateModal';
import { ExitIntentModal } from '~/components/modals/ExitIntentModal';
import { IDNAddedModal } from '~/components/modals/IDNAddedModal';
import { IDNFormModal } from '~/components/modals/IDNFormModal';
import { PatientAddedModal } from '~/components/modals/PatientAddedModal';
import { PatientCreateModal } from '~/components/modals/PatientCreateModal';
import { PrivacyNoticeModal } from '~/components/modals/PrivacyNoticeModal';
import { SettingsModal } from '~/components/modals/SettingsModal';
import { StatusInfoModal } from '~/components/modals/StatusInfoModal';
import { TermsOfUseModal } from '~/components/modals/TermsOfUseModal';

export const modals = {
  Settings: SettingsModal,
  IDNForm: IDNFormModal,
  IDNAdded: IDNAddedModal,
  DepartmentCreate: DepartmentCreateModal,
  AdminUserCreate: AdminUserCreateModal,
  AdminUserAdded: AdminUserAddedModal,
  AdminUserEdit: AdminUserEditModal,
  PatientCreate: PatientCreateModal,
  PatientAdded: PatientAddedModal,
  ExitIntent: ExitIntentModal,
  AccountActivated: AccountActivatedModal,
  TermsOfUse: TermsOfUseModal,
  PrivacyNotice: PrivacyNoticeModal,
  StatusInfo: StatusInfoModal,
} as const;

export type ModalName = keyof typeof modals;
